/** Cadre téléphone : header compact + onglets bas. Le AppShell bureau n’est pas rendu. */
import { useState, type ReactNode } from "react";
import { NAV } from "../shell/nav";
import { ThemeMenu } from "../theme/ThemeMenu";
import type { SearchOpen } from "../features/search/types";
import type { AppPage } from "../types";
import { AppHeader } from "../components/AppHeader";
import { CompanySwitch } from "../components/CompanySwitch";
import { FX_MOBILE_DOCK, fxMobileDocked } from "./mobileNav";
import "./mobile.css";

type MobileShellProps = {
  page: AppPage;
  onPage: (page: AppPage) => void;
  onSearchOpen?: (hit: SearchOpen) => void;
  children: ReactNode;
};

function IconMore() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.7" aria-hidden>
      <circle cx="5" cy="12" r="1.4" />
      <circle cx="12" cy="12" r="1.4" />
      <circle cx="19" cy="12" r="1.4" />
    </svg>
  );
}

export function MobileShell({ page, onPage, onSearchOpen, children }: MobileShellProps) {
  const [more, setMore] = useState(false);
  const dockOn = fxMobileDocked(page);

  function go(next: AppPage) {
    setMore(false);
    onPage(next);
  }

  return (
    <div className="fx-app is-mobile">
      <div className="fx-work">
        <div className="fx-m-topbar">
          <div className="fx-m-co">
            <CompanySwitch slim onOpenSettings={() => go("settings")} />
          </div>
          <AppHeader onOpen={onSearchOpen} />
        </div>
        <main className="fx-main">{children}</main>
      </div>
      {more ? (
        <div className="fx-m-more" role="dialog" aria-label="Plus">
          <button type="button" className="fx-m-more__bg" aria-label="Fermer" onClick={() => setMore(false)} />
          <div className="fx-m-more__sheet">
            <p className="fx-m-more__title">Plus</p>
            <nav className="fx-m-more__list">
              {NAV.map((item) => {
                if (item.kind === "sep" || !item.ready || !item.page || fxMobileDocked(item.page)) {
                  return null;
                }
                const on = page === item.page;
                return (
                  <button
                    key={item.id}
                    type="button"
                    className={`fx-m-more__item${on ? " is-on" : ""}`}
                    onClick={() => go(item.page!)}
                  >
                    <item.Icon />
                    {item.label}
                  </button>
                );
              })}
            </nav>
            <div className="fx-m-more__tools">
              <ThemeMenu />
            </div>
          </div>
        </div>
      ) : null}
      <nav className="fx-m-tabbar" aria-label="Navigation">
        {FX_MOBILE_DOCK.map((tab) => {
          const item = NAV.find((n) => n.kind === "item" && n.page === tab.page);
          if (!item || item.kind !== "item") return null;
          const on = page === tab.page;
          return (
            <button
              key={tab.page}
              type="button"
              className={`fx-m-tab${on ? " is-on" : ""}`}
              aria-current={on ? "page" : undefined}
              onClick={() => go(tab.page)}
            >
              <item.Icon />
              {tab.label}
            </button>
          );
        })}
        <button
          type="button"
          className={`fx-m-tab${!dockOn || more ? " is-on" : ""}`}
          aria-expanded={more}
          onClick={() => setMore((v) => !v)}
        >
          <IconMore />
          Plus
        </button>
      </nav>
    </div>
  );
}
